////
/// ============================================================================
/// COMPONENT / Floating Button
/// ============================================================================
///
/// @group components
////

export default () => {
    let open = false;
    let container = document.querySelector('.js-floatingBtn');
    let toggle = document.querySelector('.js-floatingBtnToggle');

    if (!container && !toggle) {
        return;
    }

    function createCookie(name, value, days) {
        let date,
            expires = '';

        if (days) {
            date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }

        document.cookie = name + '=' + value + expires + '; path=/';
    }

    function openNews() {
        createCookie('floatingBtn', true, 1);
        container.classList.add('is-visible');
        toggle.classList.add('is-open');
        open = true;
    }

    function closeNews() {
        container.classList.remove('is-visible');
        toggle.classList.remove('is-open');
        open = false;
    }

    toggle.addEventListener('click', function () {
        if (open) {
            closeNews();
        } else {
            openNews();
        }
    });
};
